import React from 'react'
import { observer } from 'mobx-react'
import ConfirmSheet from 'components/ConfirmSheet'
import {
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
} from 'components/ModalSheet'
import { JobManagementSelectionViewModel } from '../JobManagementViewModel'
import { pluralize } from 'utils/pluralization-util'

interface AdvanceJobsDialogProps {
  vm: JobManagementSelectionViewModel
}

export default observer(function AdvanceJobsDialog({
  vm,
}: AdvanceJobsDialogProps) {
  const selectedJobsCount = vm.selectedJobs.size
  const selectedJobsLabel = `${selectedJobsCount} ${pluralize('job', selectedJobsCount)}`

  return (
    <ConfirmSheet
      yes={`Advance ${selectedJobsLabel}`}
      state={vm.confirmAdvanceJobs}
      data-test={{
        confirm: 'advance-jobs-confirm-button',
        decline: 'advance-jobs-cancel-button',
      }}
    >
      <ModalSheetContentBlock>
        <ModalSheetContentTitle>
          Advance {selectedJobsLabel}?
        </ModalSheetContentTitle>
        <ModalSheetContentDescription>
          Advancing moves the jobs out of Pending and cannot be undone.
          {vm.earlyAdvanceJobsCount > 0 && (
            <>
              {' '}
              {vm.earlyAdvanceJobsCount} of these have not reached their advance
              date and will be advanced early.
            </>
          )}
        </ModalSheetContentDescription>
      </ModalSheetContentBlock>
    </ConfirmSheet>
  )
})
